<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">نشان شده ها</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>

    <div class="p-3 pb-6">
      <div class="d-flex justify-content-around align-items-center mb-4 bg_white rounded-pill p-2 shadow-sm">
        <div 
          class="flex-grow-1 text-center py-2 rounded-pill cursor-pointer" 
          :class="{ 'bg_light_theme text_color_white': activeTab === 'courses', 'text_color_gray': activeTab !== 'courses' }"
          @click="activeTab = 'courses'"
        >
          مضامین
        </div>
        <div style="width: 1px; height: 20px; background-color: #eee;"></div>
        <div 
          class="flex-grow-1 text-center py-2 rounded-pill cursor-pointer"
          :class="{ 'bg_light_theme text_color_white': activeTab === 'teachers', 'text_color_gray': activeTab !== 'teachers' }"
          @click="activeTab = 'teachers'"
        >
          استادان
        </div>
        <div style="width: 1px; height: 20px; background-color: #eee;"></div>
        <div 
          class="flex-grow-1 text-center py-2 rounded-pill cursor-pointer"
          :class="{ 'bg_light_theme text_color_white': activeTab === 'posts', 'text_color_gray': activeTab !== 'posts' }"
          @click="activeTab = 'posts'"
        >
          پست ها
        </div>
      </div>

      <div v-if="loading" class="text-center mt-5">
        <p>در حال دریافت معلومات...</p>
      </div>

      <div v-else>
        <div v-if="activeTab === 'courses'">
          <div v-if="bookmarkedLessons.length === 0" class="text-center mt-5 text_color_gray">
            مضمونی نشان نشده است.
          </div>
          <div v-else>
            <div v-for="(item, index) in bookmarkedLessons" :key="index" class="d-flex align-items-center justify-content-between shadow_box rounded-4 bg_white p-3 mb-3" @click="goToDetail(item.id || item.content_id)">
              <div class="d-flex align-items-center gap-3">
                 <img src="@/assets/imgs/play.svg" class="icon-size-4" alt="">
                 <div class="d-flex flex-column">
                    <p class="bold">{{ item.lesson_title || item.title }}</p>
                    <p class="text_color_gray font_small mt-1">{{ item.grade_title }} {{ item.course_title ? '- ' + item.course_title : '' }}</p>
                 </div>
              </div>
              <div class="d-flex align-items-center gap-2">
                 <p class="text_color_gray">{{ item.time || '00:00' }}</p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="activeTab === 'teachers'">
          <div v-if="bookmarkedTeachers.length === 0" class="text-center mt-5 text_color_gray">
            استادی نشان نشده است.
          </div>
          <div v-else>
            <div v-for="(teacher, index) in bookmarkedTeachers" :key="index" class="d-flex justify-content-between shadow-sm p-2 bg_white rounded-5 mb-3 cursor-pointer" @click="goToTeacher(teacher.teacher_id)">
              <img 
                style="width: 5rem; height: 5rem; object-fit: cover;" 
                :src="teacher.pic1 || require('@/assets/imgs/NoPath - Copy (5).png')" 
                class="rounded-5" 
                alt=""
                @error="$event.target.src = require('@/assets/imgs/NoPath - Copy (5).png')"
              >
              <div style="width: calc(100% - 6rem);" class="d-flex flex-column justify-content-center gap-2 overflow-hidden">
                <p class="bold">{{ teacher.name }}</p>
                <p class="font_small text_color_gray text-truncate">{{ teacher.bio || 'بدون بیوگرافی' }}</p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="activeTab === 'posts'">
          <div v-if="bookmarkedPosts.length === 0" class="text-center mt-5 text_color_gray">
            پستی نشان نشده است.
          </div>
          <div v-else>
            <div v-for="(post, index) in bookmarkedPosts" :key="index" class="d-flex align-items-center gap-3 shadow_box rounded-4 bg_white p-2 mb-3 cursor-pointer" @click="goToPost(post.id || post.post_id)">
               <img 
                 style="width: 6rem; height: 6rem; object-fit: cover;" 
                 :src="post.pic || require('@/assets/imgs/NoPath - Copy (5).png')" 
                 class="rounded-4" 
                 alt=""
                 @error="$event.target.src = require('@/assets/imgs/NoPath - Copy (5).png')"
               >
               <div class="d-flex flex-column justify-content-between h-100 py-1 overflow-hidden w-100">
                  <p class="font_small text-truncate-multiline mb-2">{{ post.caption_short }}</p>
                  <div class="d-flex justify-content-end">
                    <p class="font_small text_color_gray">{{ post.created_at_local }}</p>
                  </div>
               </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <BottomNav />
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import BottomNav from '@/components/BottomNav.vue'

export default {
  name: 'BookmarksView',
  components: {
    BottomNav
  },
  data() {
    return {
      activeTab: 'courses',
      bookmarkedLessons: [],
      bookmarkedTeachers: [],
      bookmarkedPosts: [],
      loading: false
    }
  },
  mounted() {
    this.fetchBookmarks()
  },
  methods: {
    async fetchBookmarks() {
      this.loading = true;
      try {
        const userId = localStorage.getItem('user_id');
        const formData = createFormData({
          user_id: userId
        });
        
        const response = await apiClient.post('/show_marks', formData);

        if (response.data.status === 'ok' && response.data.data) {
          this.bookmarkedLessons = response.data.data.lessons || [];
          this.bookmarkedTeachers = response.data.data.teachers || [];
          this.bookmarkedPosts = response.data.data.posts || [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    goToDetail(id) {
      if (!id) return;
      this.$router.push({ 
        name: 'LessonDetail', 
        params: { id: id } 
      });
    },
    goToTeacher(id) {
      if (!id) return;
      this.$router.push({
        name: 'TeacherProfile',
        params: { id: id }
      });
    },
    goToPost(id) {
      if (!id) return;
      this.$router.push({
        name: 'TeacherPosts',
        params: { id: id }
      });
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.bg_light_theme {
  background-color: #4A00E0; 
}
.text_color_white {
  color: white !important;
}
.text-truncate-multiline {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>